import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';

import { TecnicoFormInput } from '../../../entity-tecnicos/entity-tecnicos.model';
import {
  TecnicoResponsable,
  TecnicoResponsableFormInput
} from '../../entity-tecnico-responsable.model';
import { TecnicoFormComponent } from '../../../entity-tecnicos/components/tecnico-form/tecnico-form.component';

@Component({
  selector: 'rpe-tecnico-responsable-form',
  templateUrl: './tecnico-responsable-form.component.html',
  styleUrls: ['./tecnico-responsable-form.component.scss']
})
export class TecnicoResponsableFormComponent implements OnInit {
  @Input()
  set formInput(tecnicoResponsableFormInput: TecnicoResponsableFormInput) {
    if (tecnicoResponsableFormInput != null) {
      this._formInput = tecnicoResponsableFormInput;
      if (tecnicoResponsableFormInput.persona != null) {
        this.tecnicoFormInput = {
          action: tecnicoResponsableFormInput.action,
          direccion_geografica:
            tecnicoResponsableFormInput.direccion_geografica,
          persona: tecnicoResponsableFormInput.persona
        };
      }
    }
  }
  get formInput(): TecnicoResponsableFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<TecnicoResponsable>();
  @ViewChild(TecnicoFormComponent, { static: true })
  tecnicoForm: TecnicoFormComponent;

  _formInput: TecnicoResponsableFormInput = null;
  tecnicoFormInput: TecnicoFormInput = null;
  tecnicoResponsableFormGroup: FormGroup;
  cv: File;

  constructor(private fb: FormBuilder, private dialog: MatDialog) {}

  ngOnInit(): void {
    // Creacion de nuevo tecnico-responsable
    if (this.formInput.action == FormActionType.Add) {
      this.tecnicoResponsableFormGroup = this.fb.group({
        cjppu: ['', [Validators.required]],
        tecnico: this.tecnicoForm.createGroup()
      });
    } else {
    }

    // emit events
    this.tecnicoResponsableFormGroup.valueChanges.subscribe((_) => {
      this.formValueChanges.emit({
        ...this.tecnicoResponsableFormGroup.value
      });
    });
    this.tecnicoResponsableFormGroup.statusChanges.subscribe((f) =>
      this.formStatusChanges.emit(f)
    );
  }

  reset(): void {}

  onShowErrors(): void {
    this.tecnicoResponsableFormGroup.markAllAsTouched();
  }
}
